import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n    background-position: 0 96%;\n    background-size: 100% 12px;\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n    background-position: 0 94%;\n    background-size: 100% 10px;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  background-image: linear-gradient(", " 0%, ", " 100%);\n  background-repeat: repeat-x;\n\n  background-position: 0 92%;\n  background-size: 100% 8px;\n\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import * as React from 'react';
import styled from 'styled-components';
import media from '../media';
import { H3 } from '../Typography';
import { ADVENTURE_GREEN_STRESSED } from '../colors';
import InfoContentSimple from '../Info/InfoContent/InfoContentSimple';
var QuoteLine = styled.span(_templateObject(), ADVENTURE_GREEN_STRESSED, ADVENTURE_GREEN_STRESSED, media.from.md(_templateObject2()), media.from.lg(_templateObject3()));

var Quote = function Quote(_ref) {
  var children = _ref.children,
      _ref$component = _ref.component,
      component = _ref$component === void 0 ? H3 : _ref$component,
      _ref$noQuotes = _ref.noQuotes,
      noQuotes = _ref$noQuotes === void 0 ? false : _ref$noQuotes,
      _ref$noLine = _ref.noLine,
      noLine = _ref$noLine === void 0 ? false : _ref$noLine,
      _ref$lines = _ref.lines,
      lines = _ref$lines === void 0 ? 0 : _ref$lines,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "component", "noQuotes", "noLine", "lines"]);

  var Wrapper = !noLine ? QuoteLine : 'span';
  return /*#__PURE__*/React.createElement(InfoContentSimple, _extends({
    strong: true,
    component: component,
    lines: lines,
    title: /*#__PURE__*/React.createElement(Wrapper, null, noQuotes ? children : "\u201C" + children + "\u201D")
  }, props));
};

export default Quote;